import { render, staticRenderFns } from "./tour-temporario.vue?vue&type=template&id=770096f8&"
import script from "./tour-temporario.vue?vue&type=script&lang=js&"
export * from "./tour-temporario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VPagination,VProgressCircular,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770096f8')) {
      api.createRecord('770096f8', component.options)
    } else {
      api.reload('770096f8', component.options)
    }
    module.hot.accept("./tour-temporario.vue?vue&type=template&id=770096f8&", function () {
      api.rerender('770096f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/tour-temporario.vue"
export default component.exports